import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const TableCont = styled.div`
  margin: 0 56px 0 56px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableSearchArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 0 0 20px 0;
`;

export const TableFooterCont = styled.div`
  display: flex;
  justify-self: flex-end;
  justify-content: space-between;
  align-items: baseline;
  box-sizing: border-box;
  padding: 0 10px 32px;
  margin: auto 0 0 0;
`;

export const TableBottomMockWidth = styled.div`
  width: 237px;
  margin: 0 60px 0 0;
`;

export const SearchBoxCont = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const NewSurveyButton = styled(DefaultButton)`
  text-transform: capitalize;

  ${({ theme }: IThemeProvider) => `
    width: auto;
    margin: 0 0 0 ${theme.layout.spacing.giga};
    padding: 0 ${theme.layout.spacing.centy};
    background: ${theme.colors.primary[100]};
    border: none;
    border-radius: 8px;
    color: ${theme.colors.neutral.primary[5]};
  `};
`;
